/* eslint-disable react/require-default-props */
import { useField, useFormikContext } from 'formik';
import React, { CSSProperties, useEffect, useState } from 'react';
import { isStyleObject } from '../../../constant';
import SingleOtpInput from './Input';

const BACKSPACE = 8;
const LEFT_ARROW = 37;
const RIGHT_ARROW = 39;
const DELETE = 46;
const SPACEBAR = 32;

const OtpInput = ({
  id,
  numInputs,
  inputStyle,
  focusStyle,
  isDisabled,
  disabledStyle,
  hasErrored,
  errorStyle,
  shouldAutoFocus,
  containerStyle,
}) => {
  const [metadata] = useField(id);
  const { values, setValues } = useFormikContext();
  const [activeInput, setActiveInput] = useState(0);
  const [otp, setOtp] = useState([]);

  useEffect(() => {
    if (metadata.value) setOtp(metadata.value.toString().split(''));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [metadata.value]);

  const handleOnChange = (e) => {
    const simpleInput = (e.target).value;
    if (!isNaN(parseInt(simpleInput, 10))) {
      changeCodeAtFocus(simpleInput);
    }
  };

  // Change OTP value at focused input
  const changeCodeAtFocus = (input) => {
    const tempOtp = [...otp];
    tempOtp[activeInput] = input;
    handleOtpChange(tempOtp);
  };

  // Helper to return OTP from input
  const handleOtpChange = (updatedOtp) => {
    const otpValue = updatedOtp.join('');
    setValues({
      ...values,
      [id]: otpValue,
    });
  };

  // Focus on input by index
  const focusInput = (input) => {
    const tempActiveInput = Math.max(Math.min(numInputs - 1, input), 0);
    setActiveInput(tempActiveInput);
  };

  const focusPrevInput = () => {
    focusInput(activeInput - 1);
  };

  // Focus on next input
  const focusNextInput = () => {
    focusInput(activeInput + 1);
  };

  const handleOnKeyDown = (e) => {
    if (e.keyCode === BACKSPACE || e.key === 'Backspace') {
      e.preventDefault();
      changeCodeAtFocus('');
      focusPrevInput();
    } else if (e.keyCode === DELETE || e.key === 'Delete') {
      e.preventDefault();
      changeCodeAtFocus('');
    } else if (e.keyCode === LEFT_ARROW || e.key === 'ArrowLeft') {
      e.preventDefault();
      focusPrevInput();
    } else if (e.keyCode === RIGHT_ARROW || e.key === 'ArrowRight') {
      e.preventDefault();
      focusNextInput();
    } else if (e.keyCode === SPACEBAR || e.key === ' ' || e.key === 'Spacebar' || e.key === 'Space') {
      e.preventDefault();
    }
  };
  const handleOnInput = (e) => {
    const simpleInput = (e.target).value;
    if (!isNaN(parseInt(simpleInput, 10))) {
      focusNextInput();
    } else {
      const { nativeEvent } = e;
      if (nativeEvent.data === null && nativeEvent.inputType === 'deleteContentBackward') {
        e.preventDefault();
        changeCodeAtFocus('');
        focusPrevInput();
      }
    }
  };

  const handleOnPaste = (e) => {
    e.preventDefault();
    if (isDisabled) {
      return;
    }
    let nextActiveInput = activeInput;

    const pastedData = e.clipboardData
      .getData('text/plain')
      .slice(0, numInputs - activeInput)
      .split('');
    // Paste data from focused input onwards
    for (let pos = 0; pos < numInputs; ++pos) {
      if (pos >= activeInput && pastedData.length > 0) {
        otp[pos] = pastedData.shift();
        nextActiveInput += 1;
      }
    }
    setActiveInput(nextActiveInput);
    focusInput(nextActiveInput);
    handleOtpChange(otp);
  };

  const renderInputs = () => {
    const inputs = [];

    for (let i = 0; i < numInputs; i++) {
      inputs.push(
        <SingleOtpInput
          key={i}
          index={i}
          focus={activeInput === i}
          value={otp && otp[i]}
          onChange={handleOnChange}
          onKeyDown={handleOnKeyDown}
          onInput={handleOnInput}
          onPaste={handleOnPaste}
          onFocus={(e) => {
            setActiveInput(i);
            e.target.select();
          }}
          onBlur={() => setActiveInput(-1)}
          inputStyle={inputStyle}
          focusStyle={focusStyle}
          isLastChild={i === numInputs - 1}
          isDisabled={isDisabled}
          disabledStyle={disabledStyle}
          hasErrored={hasErrored}
          errorStyle={errorStyle}
          shouldAutoFocus={shouldAutoFocus}
        />,
      );
    }
    return inputs;
  };

  return (
    <div
      style={{
        display: 'flex',
        ...(isStyleObject(containerStyle) && containerStyle),
      }}
    >
      {renderInputs()}
    </div>
  );
};

export default OtpInput;
